
export const addVideos = (data) => (dispatch) => {
    dispatch({type: 'ADD_VIDEOS', payload: data})
}

export const addArticles = (data) => (dispatch) => {
    dispatch({type: 'ADD_ARTICLES', payload: data})
}